import { Validators } from '../../config/constants';

const validateErrors = (validators: Validators[], callback: (message: string) => void) =>
    validators.every(({ errorCondition, message }) => {
        if (errorCondition) {
            callback(message);
        }

        return !errorCondition;
    });

export default validateErrors;
